import { mapContentModules } from '../contentModuleMapper';

export const mapSharedContentModule = async ({ content, settings, siteId, locale }): Promise<Content.ContentModule> => ({
	documentType: content?.contentType,
	content: {
		properties: {
			content: {
				properties: {
					modules: (await mapSharedContent(content?.properties?.content ?? [], siteId, locale)) || null,
				},
			},
		},
	},
	settings: {
		properties: settings?.properties ?? null,
	},
});

const mapSharedContent = async (sharedContentItems: { properties }[], siteId: string, locale: string): Promise<Content.ContentModule[]> => {
	const results = await Promise.all(
		sharedContentItems.map((sharedContent) => mapContentModules(sharedContent.properties.modules.items, siteId, locale)),
	);

	return results.flat();
};
